module.exports = __webpack_public_path__ + "img/slider4.c9c0189c.jpg";